import { Notification } from '@localstack/types';
import { ReactElement } from 'react';
import { ContentModal } from '@localstack/ui';

export type NotificationModalProps = {
  notification: Optional<Notification>;
  onClose: () => void;
};

export const NotificationModal = ({ notification, onClose }: NotificationModalProps): ReactElement => (
  <ContentModal
    dialogTitle="Notification"
    // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
    dialogContent={<div dangerouslySetInnerHTML={{ __html: notification?.rich_text ?? '' }} />}
    hideDialogActions
    showCloseButton
    modalMaxWidth="md"
    open={!!notification}
    onClose={onClose}
  />
);
